const { eventUrl } = require('../../$content/events');
const { toHTML } = require('../../../src/utils/sanity/index.js');
const { imageHtml } = require('../_partials/image.js');
const Icon = require('../../utils/icon.js');

module.exports = function ({
  title,
  text,
  layout = 'mosaic',
  items,
  blockHelpers,
  ...data
}) {
  title = title != data.item?.title && title;

  if (!items) return;

  if (layout === 'columns') {
    avgWord =
      items
        ?.flatMap(({ text }) =>
          text?.flatMap(({ children }) =>
            children?.flatMap(({ text }) => text?.split(' ').length)
          )
        )
        .reduce((acc, n) => acc + n, 0) / items.length;

    if (avgWord > 75) var span = 12 / (avgWord > 110 ? 2 : 3);
  }

  return `<section class="block-flexibleContent block-flexibleContent--${layout}${
    layout == 'mosaic' ? ' mosaic' : ``
  }${items.length === 1 ? ` single` : ``}${items.length >= 4 ? ` max` : ``}"
  ${span ? ` style="--g-col-span: ${span}"` : ``} ${blockHelpers.id(data)}>
    <header>
      ${title ? `<h1>${title}</h1>` : ``}
      ${text ? toHTML(text, data) : ``}
    </header>

    <div>
      ${items?.map(processItem).join('')}
    </div>
  </section>`;

  function processItem({ callToActions = [], ...item }) {
    return {
      ...item,
      callToActions: Object.assign(callToActions?.map(processCta), {
        toString() {
          return this.join(``);
        }
      }),
      get imageHtml() {
        try {
          let image = imageHtml({
            ...this.image,
            width: layout === 'mosaic' ? 885 : 758,
            height: 758
          });

          if (layout === 'columns') {
            return image.replace(/<picture.*?<\/picture>/gs, (match) =>
              this.withCta(match)
            );
          }

          return image;
        } catch (error) {
          return ``;
        }
      },
      get textHtml() {
        return this.text ? toHTML(this.text, data) : ``;
      },
      get titleHtml() {
        if (!this.title) return ``;

        return `<h1>${
          layout === 'columns' ? this.withCta(this.title) : this.title
        }</h1>`;
      },
      get callToAction() {
        return this.callToActions?.find(({ url }) => !!url);
      },
      withCta(text, attributes = `tabindex="-1"`) {
        return this.callToAction?.wrap(text, attributes) ?? text;
      },
      toString() {
        let {
          titleHtml: title,
          textHtml: text,
          callToActions,
          imageHtml: image,
          videos
        } = this;

        return `<article class="${blockHelpers.oddOrEven(
          'imageBlock'
        )}" ${blockHelpers.id({ ...data, ...item })}>

          ${image}
    
          <div>
            <div>
              ${title}
              <div>${text}</div>
              ${callToActions}
            </div>
          </div>

          ${
            videos
              ? `<aside x-cloak>${videos
                  ?.map(
                    (url) => `<span x-data="youtubeVideo('${url}')"></span>`
                  )
                  .join('')}</aside>`
              : ``
          }
        </article>`;
      }
    };

    function processCta({ ...cta }) {
      return {
        ...cta,
        url: getUrl(cta),
        icon: Icon(layout === 'mosaic' ? 'chevron' : 'arrow-right'),
        wrap(text, attributes = '') {
          return `<a href="${this.url}"${
            attributes ? ` ${attributes}` : ``
          }>${text}</a>`;
        },
        toString() {
          return this.wrap(
            `${this.text} ${this.icon}`,
            layout === 'mosaic' ? ` class="button"` : ``
          );
        }
      };
    }

    function getUrl({ url, reference, hash }) {
      if (reference) {
        if (reference?.url) {
          url = reference.url;
        } else {
          if (reference?._type === 'event') {
            url = eventUrl(reference) + (hash ? `#${hash}` : ``);
          } else if (reference?._ref || reference?._id) {
            let page = data.links[reference?._ref || reference?._id];
            if (page) url = page + (hash ? `#${hash}` : ``);
          }
        }
      }

      return url;
    }
  }
};
